document.addEventListener("DOMContentLoaded", function () {
    console.log("TOC script loaded ✅");

    let toggleButton = document.querySelector(".ez-toc-title-toggle");
    let tocContent = document.querySelector(".ez-toc-list");

    if (!toggleButton || !tocContent) {
        console.warn("TOC elements not found ❌");
        return;
    }

    // Hide TOC by default
    tocContent.style.display = "none";

    // Click Event Listener
    toggleButton.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent link behavior
        console.log("TOC button clicked!");

        if (tocContent.style.display === "none") {
            tocContent.style.display = "block"; // Show
        } else {
            tocContent.style.display = "none"; // Hide
        }
    });

    console.log("TOC toggle script successfully added! ✅");
});
